export default {"src":"/_next/static/media/check-circle.598ae726.svg","height":20,"width":20};